import styled, { css } from 'styled-components'
import { BRAND, SPORT_EVENTS } from 'constants/appConstants'
import { theme } from 'utils/theme'

export const CardContainer = styled.div`
  box-sizing: border-box;
  min-height: ${props => props.itemHeight || '225px'};
  background: ${props => (props.contentType === SPORT_EVENTS ? theme.colors.white : theme.colors.primaryRed)};
  border: ${props => props.contentType === SPORT_EVENTS && `2px solid ${theme.colors.primaryRed}`};

  ${({ theme: { brand } }) =>
    brand === BRAND.GCAD &&
    css`
      background: ${theme.colors.gcadBlack};
      border: none;
    `}
`

export const DateContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`

export const Date = styled.div`
  background: ${props => (props.contentType === SPORT_EVENTS ? theme.colors.primaryRed : theme.colors.black)};
  font-family: AzoSans;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 7px 0;

  ${({ theme: { brand } }) =>
    brand === BRAND.GCAD &&
    css`
      font-family: 'Futura Std';
      font-weight: 650;
      color: ${theme.colors.white};
      background: ${theme.colors.black};
    `}
`

export const Month = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.09em;
  font-size: 11px;
  line-height: 16px;
  margin-top: 6px;
`

export const Day = styled.span`
  color: ${({ theme: { brand } }) => (brand === BRAND.ATH ? theme.colors.lightGold : theme.colors.gcadOrange)};
  font-size: 56px;
  line-height: 56px;
`

export const Time = styled.div`
  font-family: AzoSans;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  padding: 12px 0;
  width: 100%;
  color: ${props => (props.contentType === SPORT_EVENTS ? theme.colors.primaryRed : theme.colors.white)};

  ${({ theme: { brand } }) =>
    brand === BRAND.GCAD &&
    css`
      font-family: 'Futura Std';
      font-weight: 650;
      color: ${theme.colors.white};
    `}
`

export const EventType = styled.div`
  text-transform: capitalize;
  font-family: AzoSans;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  padding: 0 16px;

  ${({ theme: { brand } }) =>
    brand === BRAND.GCAD &&
    css`
      font-family: 'Futura Std';
      font-weight: 650;
      color: ${theme.colors.white};
    `}
`

export const EventTime = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  padding: 0 16px;

  ${({ theme: { brand } }) =>
    brand === BRAND.GCAD &&
    css`
      font-family: 'Futura Std';
      font-weight: 650;
      color: ${theme.colors.white};
    `}
`

export const InfoContainer = styled.div`
  padding: 20px 24px;
  color: ${props => (props.contentType === SPORT_EVENTS ? theme.colors.primaryRed : theme.colors.white)};
`

export const Title = styled.h2`
  font-family: Bison;
  font-weight: 700;
  font-size: 36px;
  line-height: 40px;
  margin-bottom: 6px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${({ theme: { brand } }) =>
    brand === BRAND.GCAD &&
    css`
      font-family: 'Futura Std';
      font-weight: 700;
      font-size: 28px;
      color: ${theme.colors.white};
    `}
`

export const Description = styled.p`
  margin-bottom: 0;
  font-family: AzoSans;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;

  ${({ theme: { brand } }) =>
    brand === BRAND.GCAD &&
    css`
      font-family: 'Futura Std';
      font-weight: 650;
      color: ${theme.colors.white};
    `}
`
